<section class="container">
  <h1>Desculpe, não encontramos essa página.</h1>
  <img
    alt="logotipo da empresa"
    class="image-logo"
    src="assets/images/404.png"
  />
  <p>O conteúdo também pode ter sido removido, ou não estar mais disponível.</p>
</section>
